// data-turbo-confirm opens the layout's <dialog id="confirm-dialog"> instead of window.confirm (CORE-013:
// „Opravdu chcete smazat tento záznam?“ with „ANO, SMAZAT“ / „Zpět“). The dialog's form method=dialog sets returnValue.
// A non-delete confirm sets data-turbo-confirm-button on the form: its label on a primary (not error) button, restored
// on close.
type ConfirmMethod = (message: string, element?: Element) => Promise<boolean>

declare global {
  interface Window {
    Turbo?: { config: { forms: { confirm: ConfirmMethod } } }
  }
}

const confirmWithDialog: ConfirmMethod = (message, element) => {
  const dialog = document.getElementById('confirm-dialog')
  if (!(dialog instanceof HTMLDialogElement)) return Promise.resolve(window.confirm(message))

  const text = dialog.querySelector('[data-confirm-message]')
  if (text) text.textContent = message
  const button = dialog.querySelector<HTMLButtonElement>('button[value="confirm"]')
  const label = element?.getAttribute('data-turbo-confirm-button')
  const defaultLabel = button?.textContent ?? ''
  if (button && label) {
    button.textContent = label
    button.classList.replace('btn-error', 'btn-primary')
  }
  dialog.returnValue = ''
  dialog.showModal()
  return new Promise((resolve) => {
    dialog.addEventListener('close', () => {
      if (button && label) {
        button.textContent = defaultLabel
        button.classList.replace('btn-primary', 'btn-error')
      }
      resolve(dialog.returnValue === 'confirm')
    }, { once: true })
  })
}

if (window.Turbo) window.Turbo.config.forms.confirm = confirmWithDialog

export {}
